import { render, staticRenderFns } from "./failedList.vue?vue&type=template&id=6be1dff8&"
import script from "./failedList.vue?vue&type=script&lang=js&"
export * from "./failedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports